export default "__VITE_ASSET__CTRnJfWC__"